import styled from 'styled-components'

export const Slider = styled.div`
  .slider {
    max-width: 430px;

    .slick-slider {
      .slick-list {
        overflow: visible;
        .slick-track {
          display: flex;
          align-items: stretch;
        }
      }

      .slick-slide {
        display: block;
        padding: 0 4px;
        height: inherit;

        div {
          height: 100%;
        }
      }

      .slick-dots {
        position: relative;
        bottom: auto;
        margin-top: 16px;

        li {
          transition: all 0.3s linear;
          transform-origin: center;
          button {
            margin-top: 0;
          }
        }
      }
    }
  }
`

export const TestimonialCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: var(--primary100);
  border: 1px solid var(--primary200);
  border-radius: 12px;

  p {
    padding-top: 16px;
  }
`
